// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdditionalOptions_btnOptions__ZzJBN button {
    margin-right: 10px;
    border: none;
    border-radius: 3px;
    font-size: 15px;
}
.AdditionalOptions_btnOptions__ZzJBN {
    padding: 10px 50px;
}
.AdditionalOptions_btnOptions__ZzJBN button > img{
   width:"100% !important";
   height:"100% !important"
}

.AdditionalOptions_moreOptions__P89o6 {
    bottom: -6px;
    height: 10px;
    width: 10px;
    right: 35px;
}

.AdditionalOptions_moreOptions__P89o6:focus {
    outline: none;
}

.AdditionalOptions_menuGrid__4zYtb{
    font-size: 12;
    margin-right: -20px;
    &:hover {
        backgroundColor: '#f0f0f0',
      }
}

.AdditionalOptions_menuGridLine__9Roy7{
    font-size: 12;
    &:hover {
        backgroundColor: '#f0f0f0',
      }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ChatBotComponent/AdditionalOptions/AdditionalOptions.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;GACG,uBAAuB;GACvB;AACH;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;QACI;MACF;AACN;;AAEA;IACI,aAAa;IACb;QACI;MACF;AACN","sourcesContent":[".btnOptions button {\n    margin-right: 10px;\n    border: none;\n    border-radius: 3px;\n    font-size: 15px;\n}\n.btnOptions {\n    padding: 10px 50px;\n}\n.btnOptions button > img{\n   width:\"100% !important\";\n   height:\"100% !important\"\n}\n\n.moreOptions {\n    bottom: -6px;\n    height: 10px;\n    width: 10px;\n    right: 35px;\n}\n\n.moreOptions:focus {\n    outline: none;\n}\n\n.menuGrid{\n    font-size: 12;\n    margin-right: -20px;\n    &:hover {\n        backgroundColor: '#f0f0f0',\n      }\n}\n\n.menuGridLine{\n    font-size: 12;\n    &:hover {\n        backgroundColor: '#f0f0f0',\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnOptions": `AdditionalOptions_btnOptions__ZzJBN`,
	"moreOptions": `AdditionalOptions_moreOptions__P89o6`,
	"menuGrid": `AdditionalOptions_menuGrid__4zYtb`,
	"menuGridLine": `AdditionalOptions_menuGridLine__9Roy7`
};
export default ___CSS_LOADER_EXPORT___;
